import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { IBotDetail } from 'interface';
import useBotDetails from 'screens/hooks/useBotDetails';
import Loader from 'components/Loader';
import NotExist from 'components/NotExist';
import InternalError from 'components/InternalError';
import AccessDenied from 'components/AccessDenied';
import BotAuthenticate from 'components/BotAuthenticate';
import Chatbot from 'screens/Chatbot';
import ContextPanel from 'screens/ContextPanel';

const Home = () => {
    const NOT_EXIST = 400;
    const INTERNAL_ERROR = 500;
    const botId = '733f2098-1964-40e6-a956-285898ba7ff7'; // '733f2098-1964-40e6-a956-285898ba7ff7';

    const { botDetailResponse, loading, statusCode } = useBotDetails({ botId });
    const [botAuthenticated, setBotAuthenticated] = useState(null);
    const [botResponse, setBotResponse] = useState(null);

    const botDetail: IBotDetail = botDetailResponse?.botDetail;
    const isPasswordProtected = botDetail?.botSettings.isPasswordProtected;
    const isPublic = botDetail?.botSettings.isPublic;

    useEffect(() => {
        localStorage.removeItem('@clientMessagesLength')
        localStorage.removeItem('@messagesLength')

    }, [])

    if (loading) return <Loader />;
    if (statusCode === NOT_EXIST) return <NotExist />;
    if (statusCode === INTERNAL_ERROR) return <InternalError />;
    if (!isPublic) return <AccessDenied botId={botDetail?.botInfo.botId} />;
    if (isPasswordProtected && !botAuthenticated) {
        return <BotAuthenticate botDetail={botDetail} setBotAuthenticated={setBotAuthenticated} />;
    }

    const resetContext = () => setBotResponse(null);

    return (
        <>
            {botDetail && <Chatbot botDetail={botDetail} setBotResponse={setBotResponse} resetContext={resetContext} />}
            {botResponse && <ContextPanel botDetail={botDetail} botResponse={botResponse} />}
        </>
    );
};

export default Home;
